module.exports = __webpack_public_path__ + "img/15m.344c80f7.jpg";